const TAG_RE = /<[a-z][\s\S]*>/i;

export function stripHtmlToPlainText(html) {
  return String(html || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function toGalleryProseHtml(value) {
  const text = String(value || '').trim();
  if (!text || !stripHtmlToPlainText(text)) {
    return '';
  }
  if (TAG_RE.test(text)) {
    return text;
  }
  return `<p>${text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</p>`;
}
